import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Amplify } from 'aws-amplify';
import { provideMarkdown } from 'ngx-markdown';

import { routes } from './app.routes';
import { addAuthInterceptor, addTrackerInterceptor } from './interceptors/add-auth.interceptor';
import { environment } from '@environments/environment';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

// LCR Configuration
// const amplifyconfig = {
//   region: "eu-west-1",
//   userPoolId: "eu-west-1_0p2g8hTdH",
//   userPoolWebClientId: "6g97t0e0g3t0skvkfnen0jvukd",
//   authenticationFlowType: "CUSTOM_AUTH"
// };

// For backward compatibility, transform to the format expected by Amplify.configure()
// const awsExports: any = {
//   "aws_project_region": environment.cognito.region,
//   "aws_cognito_region": environment.cognito.region,
//   "aws_user_pools_id": environment.cognito.userPoolId,
//   "aws_user_pools_web_client_id": environment.cognito.userPoolClientId,
// };

// Amplify.configure({
//   ...awsExports,
//   Auth: {
//     authenticationFlowType: 'CUSTOM_WITHOUT_SRP'
//   }
// });

// // Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: environment.cognito.userPoolClientId,
      userPoolId: environment.cognito.userPoolId,
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideHttpClient(withInterceptors([addAuthInterceptor])),
    provideAnimations(),
    provideMarkdown(),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: LOCALE_ID, useValue: 'en-GB' }
  ]
};
